(function($){
    'use strict';

  $('.select:not(.select__results-per-page) select').change(function() {
		var $select = $(this),
			$selectContainer = $select.closest('.select'),
			language = $select.val(),
			$content = $selectContainer.find('.select__content[data-language="' + language + '"]');

		$selectContainer.find('.active').removeClass('active');
		$content.addClass('active');
	});

  $('.js-submit-form').change(function() {
  	$('.js-search').submit();
  });
}(jQuery));